import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LineDashboardComponent } from './line-dashboard.component';
import { PrivilegeCheckerService } from 'src/app/core/services/privilege-checker.service';
import { NgxPermissionsGuard } from 'ngx-permissions';


const routes: Routes = [
  {
    path: '',
    component: LineDashboardComponent,
    // canActivate: [PrivilegeCheckerService],
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'Line Dashboard',
        redirectTo: '/no-privilage'
      }
    }
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LineDashboardRoutingModule { }
